import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-drill-down',
  templateUrl: './drill-down.component.html',
  styleUrls: ['./drill-down.component.scss']
})
export class DrillDownComponent implements OnInit {
  @Input() set categories(value: any) {
    if (value.categoriesList?.length) {
      this.categoryList = value.categoriesList;
      this.pageOfCurrentCategory = value.categoriesList.findIndex((item: any) => item.uuid === value.activeCategory);
    }
  };

  pageOfCurrentCategory!: number;

  categoryList: any[] = [];

  constructor() {}

  ngOnInit(): void {
  }

}
